import Dialog from '@mui/material/Dialog';
import styled from '@mui/material/styles/styled';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiPaper-root': {
        boxShadow: '0px 4px 19px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: '24px',
    },
    '& .MuiDialogTitle-root': {
        fontSize: '35px',
        fontWeight: 500,
    },
    '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root':
        {
            backgroundColor: theme.palette.info.main,
        },
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
        border: 'none',
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));
